/* La planilla de Torrecillas, ordenada como SALIDAS Y CUST.
 *
 * Lautaro Díaz (Satelital), ticket #432, 16/10/2026: «Esas planillas
 * TORRECILLAS son las que envía Tráfico de Río Grande, y la de SALIDAS Y CUST
 * es la plantilla que yo tengo para ordenar los datos como nosotros lo
 * hacemos. […] Y que a su vez esa info se llene en la planilla ONLY BITRENES
 * […] y como último paso que según esa planilla se vayan cargando los
 * enganches».
 *
 * ── LAS DOS TORRECILLAS ─────────────────────────────────────────────────────
 *
 * Llegan dos, iguales de forma: una de TTES. CANTARINI (TC) y otra de
 * TRANSCAN CARGAS (TCC). Arriba la fecha («16 DE OCTUBRE 2026») y la empresa;
 * debajo los títulos Nº TRACTOR · Patente Tractor · Titular · CONDICION · INT
 * (el semi) · Patente Semi · Titular · condicion · FAC · Apellido y Nombre
 * Chofer · DNI · Lugar de Carga · TELEFONO. Se leen por el título, no por la
 * posición: si un día suman una columna, sigue andando.
 *
 * ── SALIDAS Y CUST ──────────────────────────────────────────────────────────
 *
 * Su plantilla: un bloque por empresa (primero TC, después TCC) con la fecha
 * y el nombre de la empresa arriba, y las columnas Dia de Carga · Hora de
 * Salidas · Satelital · Patente Tractor · Int de Tractores · Int de Semi ·
 * Patentes de Semis · Marcas · Apellido y Nombre Chofer · DNI · TELEFONO ·
 * Lugar de Carga · Caracterticas del viaje · ID. El satelital sale del padrón
 * del tractor (CAR TRUCK o MICHELIN), la marca del padrón del semi. La
 * custodia («Características») la decide él: se le propone la última que
 * usó para ese lugar, y «A GALLEGOS» para la 2da parte de cada bitren.
 *
 * ── LOS BITRENES ────────────────────────────────────────────────────────────
 *
 * En la TCC cada bitren sale en dos filas seguidas: el semi par con el
 * titular y el impar con el que lo cruza hasta Gallegos (1560 con el 1044 y
 * 1561 con el 1023). Son los semis de bitren del padrón (`tipo_acoplado`
 * «semi», la serie 1500) y los playos 25xx (`tipo_acoplado` «playo», 2500 a
 * 2519), con la misma regla y cada serie por su lado: un semi nunca va con un
 * playo. Ésos van a ARRIBOS BITREN de su ONLY BITRENES y a Enganches; los
 * furgones y los playos de TC, no. Los playos van desde el 19/10 (Lautaro:
 * «SISI, LOS BITRENES SE AGREGAN EN ARRIBOS Y SALIDAS»).
 *
 * Todo acá es puro: lo prueban los tests con datos inventados.
 */

import { colALetra, fechaASerial, refDe } from "./planilla";
import { rangoCombinada } from "./planillaCombinadas";

export const TITULOS = [
  "Dia de Carga ", " Hora de Salidas", "Satelital ", "Patente Tractor",
  "Int de Tractores", "Int de Semi", "Patentes de Semis", "Marcas",
  "Apellido y Nombre Chofer", "DNI", "TELEFONO", "Lugar de Carga",
  "Caracterticas del viaje", "ID",
];

export const EMPRESAS = {
  TC: "TTES. TRANSPORTE CANTARINI S.R.L.",
  TCC: "TRANSCAN CARGAS S.R.L.",
};

export const HOJA_SALIDAS = "SALIDAS DE RGD TC";
export const HORA = "18:00HS";
export const A_GALLEGOS = "A GALLEGOS";

/* FAPESA (ticket 611, Lautaro, 02/11, con su Excel de días de ingreso al
 * cliente): lo que carga un día entra a Cerri cuatro días después, y si es
 * expreso, tres (carga el LUNES → entra el VIERNES, o el JUEVES si es
 * expreso). Las características del viaje salen de ahí: carga el 30/10
 * como FAPESA TV EXP → «EN CERRI LUN 2». */
const DIAS_CORTOS = ["DOM", "LUN", "MAR", "MIE", "JUE", "VIE", "SAB"];
const FAPESA_DIAS = { "FAPESA TV": 4, "FAPESA TV EXP": 3 };

export const esFapesa = (lugar) => String(lugar || "").trim().replace(/\s+/g, " ") in FAPESA_DIAS;

export function caractFapesa(lugar, fechaISO) {
  const dias = FAPESA_DIAS[String(lugar || "").trim().replace(/\s+/g, " ")];
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(fechaISO || ""));
  if (!dias || !m) return "";
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + dias));
  return `EN CERRI ${DIAS_CORTOS[d.getUTCDay()]} ${d.getUTCDate()}`;
}

/* Los CUIT del padrón de tractores (`tractores.satelital`). */
export const SATELITALES = { "30717246086": "CAR-TRUCK", "30525514885": "MICHELIN" };

/* Cómo escribe él los lugares que Río Grande escribe largos. */
export const LUGARES = { "RADIO VICTORIA": "R.VICTORIA", FAPESA: "FAPESA TV" };

const MESES = {
  ENERO: 1, FEBRERO: 2, MARZO: 3, ABRIL: 4, MAYO: 5, JUNIO: 6, JULIO: 7,
  AGOSTO: 8, SEPTIEMBRE: 9, SETIEMBRE: 9, OCTUBRE: 10, NOVIEMBRE: 11, DICIEMBRE: 12,
};

export const pelado = (v) =>
  String(v ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

const txt = (v) => String(v ?? "").replace(/\s+/g, " ").trim();
const dd = (n) => String(n).padStart(2, "0");

/* ── «PP» EN Nº TRACTOR ES FLT ───────────────────────────────────────────────
 *
 * Río Grande escribe «PP» en Nº TRACTOR cuando el camión es de un tercero, y
 * siempre trae la patente en Patente Tractor. Lautaro, 19/10: «LOS QUE DIGAN
 * PP VOS PONELOS COMO FLT PORFA». Es lo que él venía escribiendo a mano en TR
 * / TRA de sus planillas, con la patente en su columna.
 *
 * Se cambia al leer (`leerTorrecillas`), así que llega igual a la pantalla, a
 * SALIDAS Y CUST, a ARRIBOS BITREN y a lo que se arme desde acá. La palabra
 * entera, sin importar mayúsculas, puntos, espacios o paréntesis («pp»,
 * «P.P.», «(PP)»): una patente que empieza o termina con PP («PPJ 411», un
 * camión de verdad, o «AA123PP») queda como vino. */
export const FLT = "FLT";

export const internoDeTractor = (v) => (pelado(v) === "PP" ? FLT : txt(v));

/* «16 DE OCTUBRE 2026», «16 DE OCTUBRE DE 2026» o una fecha de Excel → ISO. */
export function fechaDeTitulo(v) {
  if (v instanceof Date && !Number.isNaN(v.getTime())) {
    return `${v.getFullYear()}-${dd(v.getMonth() + 1)}-${dd(v.getDate())}`;
  }
  const s = txt(v).toUpperCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  const m = /(\d{1,2})\s+DE\s+([A-Z]+)\s+(?:DE(?:L)?\s+)?(\d{4})/.exec(s);
  if (!m || !MESES[m[2]]) return "";
  return `${m[3]}-${dd(MESES[m[2]])}-${dd(m[1])}`;
}

const COLUMNAS = {
  tractor: ["NTRACTOR", "NROTRACTOR", "TRACTOR"],
  patTractor: ["PATENTETRACTOR"],
  semi: ["INT", "INTSEMI", "NSEMI", "SEMI"],
  patSemi: ["PATENTESEMI"],
  chofer: ["APELLIDOYNOMBRECHOFER", "CHOFER", "APELLIDOYNOMBRE"],
  dni: ["DNI"],
  lugar: ["LUGARDECARGA", "LUGAR"],
  tel: ["TELEFONO", "TEL"],
};

function columnasDe(fila) {
  const out = {};
  (fila || []).forEach((v, i) => {
    const p = pelado(v);
    for (const [k, alias] of Object.entries(COLUMNAS)) {
      if (out[k] === undefined && alias.includes(p)) out[k] = i;
    }
  });
  return out.tractor !== undefined && out.semi !== undefined && out.chofer !== undefined
    ? out
    : null;
}

/* Una hoja de Torrecillas (matriz de celdas) → `{fecha, empresa, filas}` o
   null si no es una Torrecillas. */
export function leerTorrecillas(matriz) {
  const filas = matriz || [];
  let desde = -1;
  let cols = null;
  for (let i = 0; i < Math.min(filas.length, 10); i++) {
    cols = columnasDe(filas[i]);
    if (cols) {
      desde = i;
      break;
    }
  }
  if (!cols) return null;
  let fecha = "";
  let empresa = "";
  for (const fila of filas.slice(0, desde)) {
    for (const v of fila || []) {
      if (!fecha) fecha = fechaDeTitulo(v);
      const p = pelado(v);
      if (!empresa && p.includes("TRANSCAN")) empresa = "TCC";
      if (!empresa && p.includes("CANTARINI")) empresa = "TC";
    }
  }
  const leidas = [];
  for (const fila of filas.slice(desde + 1)) {
    const val = (k) => (cols[k] === undefined ? "" : txt((fila || [])[cols[k]]));
    const f = {
      tractor: internoDeTractor(val("tractor")), patTractor: val("patTractor"), semi: val("semi"),
      patSemi: val("patSemi"), chofer: val("chofer"), dni: val("dni"),
      tel: val("tel"), lugar: val("lugar"),
    };
    if (!f.tractor && !f.semi && !f.chofer) continue;
    leidas.push(f);
  }
  if (!empresa) {
    // Sin el nombre arriba: lo dice el titular del semi de la mayoría.
    const tcc = leidas.filter((f) => /^1[5-9]\d\d$|^2\d{3}$/.test(f.semi)).length;
    empresa = tcc > leidas.length / 2 ? "TCC" : "TC";
  }
  return { fecha, empresa, filas: leidas };
}

export const lugarCorto = (v) => LUGARES[txt(v).toUpperCase()] || txt(v).toUpperCase();

/* Si el interno es un semi de bitren: lo dice el padrón, y si el padrón no
   lo tiene, la serie 1500. */
export function esSemiDeBitren(interno, furgones) {
  const f = furgones?.[String(interno)];
  if (f && f.tipo_acoplado) return f.tipo_acoplado === "semi";
  return /^15\d\d$/.test(String(interno));
}

/* Si el interno es un playo de bitren: la serie 2500, salvo que el padrón
   diga que es otra cosa. Los playos de TC (los 100 a 510) no son de bitren. */
export function esPlayoDeBitren(interno, furgones) {
  if (!/^25\d\d$/.test(String(interno))) return false;
  const f = furgones?.[String(interno)];
  return !f?.tipo_acoplado || f.tipo_acoplado === "playo";
}

/* La serie de bitren del interno: «semi» (15xx), «playo» (25xx) o "". */
export function serieDeBitren(interno, furgones) {
  if (esSemiDeBitren(interno, furgones)) return "semi";
  return esPlayoDeBitren(interno, furgones) ? "playo" : "";
}

/* Las parejas de bitren de un bloque: `[[i, j]]`, índices de la 1ra (el par)
   y la 2da (el impar), que vienen en filas seguidas y son de la misma serie. */
export function parejas(filas, furgones) {
  const out = [];
  for (let i = 0; i + 1 < filas.length; i++) {
    const a = parseInt(filas[i].semi, 10);
    const b = parseInt(filas[i + 1].semi, 10);
    if (!Number.isFinite(a) || !Number.isFinite(b)) continue;
    if (Math.min(a, b) % 2 !== 0 || Math.abs(a - b) !== 1) continue;
    const serie = serieDeBitren(a, furgones);
    if (!serie || serieDeBitren(b, furgones) !== serie) continue;
    out.push(a < b ? [i, i + 1] : [i + 1, i]);
    i++;
  }
  return out;
}

/* Lo que él escribió en LUG / DIA para cada cliente en su ONLY BITRENES (la
   1ra fila de cada bitren): de ahí sale la custodia que se le propone. */
export function custodiasDeArribos(hoja) {
  const out = {};
  const enc = encabezadoArribos(hoja);
  if (!enc) return out;
  const { fila, cols } = enc;
  if (cols.cliente === undefined || cols.lug === undefined) return out;
  for (const r of (hoja.celdas || []).slice(fila + 1)) {
    const c = txt(r?.[cols.cliente]).toUpperCase();
    const l = txt(r?.[cols.lug]).toUpperCase();
    if (c && l && l !== A_GALLEGOS) out[c] = l;
  }
  return out;
}

/* ── EL SATELITAL DE LOS FLETEROS ────────────────────────────────────────────
 *
 * Lautaro, 21/10 (mail «TORRECILLAS»): «A LOS FLETEROS TMB LES COMPLETES EL
 * SATELITAL». El satelital se buscaba sólo por el interno, y el fletero
 * llega con «PP» (FLT) en Nº TRACTOR: salía vacío aunque el camión estuviera
 * en el padrón con su patente y su satelital (el 118 es KBH685 y el 290
 * JUG812, los dos con CAR-TRUCK). Ahora, si por el interno no sale, se busca
 * la patente de «Patente Tractor» en el `dominio` del padrón, las dos sin
 * espacios ni guiones y en mayúsculas («KBH 685», «kbh-685» y «KBH685» son
 * el mismo). El fletero que no está en el padrón queda vacío, como antes. */
export function tractoresPorPatente(tractores) {
  const out = {};
  for (const t of Object.values(tractores || {})) {
    const p = pelado(t?.dominio);
    if (!p) continue;
    // Si la patente estuviera dos veces, gana la que tiene el satelital.
    if (!out[p] || (!SATELITALES[String(out[p].satelital ?? "")] && SATELITALES[String(t.satelital ?? "")])) out[p] = t;
  }
  return out;
}

/* Y EL FLETERO QUE NO ESTÁ EN EL PADRÓN (ticket 562, Lautaro, 29/10:
 * «CUANDO YO SUELTE LAS TORRECILLAS TCC, AHÍ EN EL KOM 245 PONELE SATELITAL
 * SITRACK PORFA»): su satelital va en la tabla `satelital_fleteros` (patente
 * pelada → proveedor), la misma que lee FlotaBot para el correo de
 * Enganches. `fleteros` es `{KOM245: "SITRACK"}` (`services/torrecillas.
 * padron`). EL PADRÓN MANDA, como en el bot: una patente que está en
 * `tractores` se contesta con el padrón aunque ahí no tenga satelital, y la
 * tabla sólo contesta por las que no están. El proveedor es un CUIT (se
 * muestra como en el padrón: CAR-TRUCK, MICHELIN) o el nombre de uno sin
 * CUIT (SITRACK, HAWK), que va tal cual. */
export const nombreDeSatelital = (proveedor) => {
  const p = String(proveedor ?? "").trim();
  return SATELITALES[p] || p.toUpperCase();
};

export function satelitalDe(f, tractores, porPatente = tractoresPorPatente(tractores), fleteros = {}) {
  const por = (t) => SATELITALES[String(t?.satelital ?? "")] || "";
  const patente = pelado(f.patTractor);
  const delPadron = por(tractores?.[f.tractor]) || por(porPatente[patente]);
  if (delPadron || !patente || porPatente[patente]) return delPadron;
  return nombreDeSatelital(fleteros?.[patente]);
}

/* Las Torrecillas leídas → los bloques de SALIDAS Y CUST, en el orden de su
   plantilla (TC y después TCC), cada fila con lo que se muestra y se baja. */
export function armarSalidas(lecturas, { tractores = {}, furgones = {}, custodias = {}, fleteros = {} } = {}) {
  const orden = ["TC", "TCC"];
  const porPatente = tractoresPorPatente(tractores);
  const porEmpresa = {};
  for (const l of lecturas || []) {
    if (!l) continue;
    (porEmpresa[l.empresa] = porEmpresa[l.empresa] || []).push(...l.filas);
  }
  return orden
    .filter((e) => porEmpresa[e]?.length)
    .map((empresa) => {
      const crudas = porEmpresa[empresa];
      const pares = parejas(crudas, furgones);
      const parte = {};
      pares.forEach(([a, b], n) => {
        parte[a] = { bitren: n, cual: 1 };
        parte[b] = { bitren: n, cual: 2 };
      });
      const filas = crudas.map((f, i) => {
        const lugar = lugarCorto(f.lugar);
        const p = parte[i];
        return {
          ...f,
          lugar,
          satelital: satelitalDe(f, tractores, porPatente, fleteros),
          marca: txt(furgones[f.semi]?.marca).toUpperCase(),
          caract: p?.cual === 2 ? A_GALLEGOS : custodias[lugar] || "",
          parte: p || null,
        };
      });
      return { empresa, titulo: EMPRESAS[empresa], filas, pares };
    });
}

const numero = (v) => (/^[1-9]\d{0,9}$/.test(String(v)) ? Number(v) : v || "");

const fechaLarga = (iso) => {
  const [a, m, d] = String(iso).split("-");
  const mes = Object.keys(MESES).find((k) => MESES[k] === Number(m) && k !== "SETIEMBRE");
  return iso ? `${Number(d)} DE ${mes} DE ${a}` : "";
};

/* Como en su SALIDAS Y CUST: el Día de Carga es una fecha de verdad que se
   ve 19/10/2026 en cualquier Excel, y el DNI va con los puntos de los miles.
   La fecha va como el número de días de Excel, entero: con un Date, SheetJS
   la corría con el huso del navegador y en la Argentina quedaba el día
   anterior a las 23:59, así que se veía 18/10/2026. */
export const FORMATO_FECHA = "dd/mm/yyyy";
export const FORMATO_DNI = "#,##0";

/* Los anchos de sus columnas A a N y el alto de sus filas (el de la fila de
   los títulos es más alto: van en dos renglones). */
export const ANCHOS_SALIDAS = [11.57, 10.71, 13.71, 12.29, 11.14, 10.86, 10.57, 15.57, 27.29, 13.14, 20, 22.57, 10.71, 15.57];
export const ALTO_FILA = 24.95;
export const ALTO_TITULOS = 35.1;

function celdaFecha(iso) {
  const [a, m, d] = String(iso || "").split("-");
  const serial = iso ? fechaASerial(`${d}/${m}/${a}`) : null;
  return serial === null ? "" : { t: "n", v: serial, z: FORMATO_FECHA };
}

const celdaDni = (v) => {
  const n = numero(v);
  return typeof n === "number" ? { t: "n", v: n, z: FORMATO_DNI } : n;
};

/* La hoja SALIDAS Y CUST: `{matriz, combinadas, anchos, altos}` (combinadas
   como «A1:G1»; la fecha y el DNI, como celdas con su formato). */
export function matrizSalidas(bloques, { fecha, hora = HORA }) {
  const matriz = [];
  const combinadas = [];
  const altos = [];
  for (const b of bloques) {
    const r = matriz.length + 1;
    matriz.push([fechaLarga(fecha), "", "", "", "", "", "", b.titulo, "", "", "", "", "", ""]);
    combinadas.push(`A${r}:G${r}`, `H${r}:N${r}`);
    matriz.push([...TITULOS]);
    altos.push(ALTO_FILA, ALTO_TITULOS);
    for (const f of b.filas) {
      matriz.push([
        celdaFecha(fecha), hora, f.satelital, f.patTractor, numero(f.tractor), numero(f.semi),
        f.patSemi, f.marca, f.chofer, celdaDni(f.dni), f.tel, f.lugar, f.caract, "",
      ]);
      altos.push(ALTO_FILA);
    }
  }
  return { matriz, combinadas, anchos: [...ANCHOS_SALIDAS], altos };
}

/* El nombre del archivo que se baja, sin «.xlsx» («SALIDAS Y CUST 19-10-2026»):
   es también el título de la hoja impresa. */
export function nombreSalidas(fecha) {
  const [a, m, d] = String(fecha || "").split("-");
  return fecha ? `SALIDAS Y CUST ${d}-${m}-${a}` : "SALIDAS Y CUST";
}

/* SALIDAS Y CUST para imprimir desde la pantalla, sin abrir el Excel (ticket
   452, Lautaro, 19/10: «EN ONLY BITRENES Y EN LAS SALIDAS Y CUST PUEDE HABER
   UN BOTON DE IMPRIMIR?»). Es la hoja de `matrizSalidas`, la misma que se
   baja, en el formato de las planillas del hub (`shared/planillaImprimir`):
   el día y el DNI como números con su formato (se ven 19/10/2026 y
   11.111.111, como en el Excel), los anchos y los altos pasados a px, la
   fecha y la empresa en negrita y los títulos en negrita sobre gris. Todo
   centrado. */
const PX_POR_ANCHO_EXCEL = 7; // un carácter de Calibri 11, más 5 px de margen
const PX_POR_PUNTO = 4 / 3;

export function hojaSalidasParaImprimir(bloques, { fecha, hora = HORA }) {
  const { matriz, combinadas, anchos, altos } = matrizSalidas(bloques, { fecha, hora });
  const formato = {};
  const celdas = matriz.map((fila, r) => fila.map((v, c) => {
    const ref = refDe(r, c);
    formato[ref] = { align: "center" };
    if (v && typeof v === "object") {
      formato[ref].num = v.z === FORMATO_FECHA ? "fecha" : "miles";
      return v.v;
    }
    return v;
  }));
  let r = 0;
  for (const b of bloques) {
    for (let c = 0; c < TITULOS.length; c += 1) {
      Object.assign(formato[refDe(r, c)], { bold: true });
      Object.assign(formato[refDe(r + 1, c)], { bold: true, bg: "#d9d9d9", valign: "middle" });
    }
    r += 2 + b.filas.length;
  }
  return {
    celdas,
    formato,
    combinadas,
    anchos: anchos.map((w) => Math.round(w * PX_POR_ANCHO_EXCEL + 5)),
    altos: altos.map((pt) => Math.round(pt * PX_POR_PUNTO)),
  };
}

/* ── ARRIBOS BITREN de su ONLY BITRENES ──────────────────────────────────── */

const ALIAS_ARRIBOS = {
  fc: ["FC"], fs: ["FS"], bitren: ["BITREN", "FUR"], tra: ["TRA", "TRAC", "TRACTOR"],
  chofer: ["CHOFER", "CHOFERES"], cliente: ["CLIENTE", "CLIENTES"], lug: ["LUGDIA"],
};

export function encabezadoArribos(hoja) {
  const celdas = hoja?.celdas || [];
  for (let i = 0; i < Math.min(celdas.length, 6); i++) {
    const cols = {};
    (celdas[i] || []).forEach((v, j) => {
      const p = pelado(v);
      for (const [k, al] of Object.entries(ALIAS_ARRIBOS)) {
        if (cols[k] === undefined && al.includes(p)) cols[k] = j;
      }
    });
    if (cols.bitren !== undefined && cols.chofer !== undefined) return { fila: i, cols };
  }
  return null;
}

/* La hoja de arribos de una planilla del hub (`datos.hojas`), o -1. */
export function hojaDeArribos(datos) {
  const hojas = datos?.hojas || [];
  const i = hojas.findIndex((h) => pelado(h.nombre).includes("ARRIBO") && encabezadoArribos(h));
  return i;
}

/* Las filas de bitren de los bloques, para ARRIBOS y para Enganches:
   `[{primera, segunda}]` con cada parte como fila de `armarSalidas`. */
export function bitrenesDe(bloques) {
  const out = [];
  for (const b of bloques) {
    for (const [i, j] of b.pares) out.push({ primera: b.filas[i], segunda: b.filas[j] });
  }
  return out;
}

/* El día siguiente a una fecha AAAA-MM-DD (con el fin de mes y de año), o ""
   si no es una fecha. */
export function diaSiguiente(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso ?? ""));
  if (!m) return "";
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  if (d.getUTCMonth() !== +m[2] - 1 || d.getUTCDate() !== +m[3]) return "";
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}

/* Lo que ocupa un bitren en ARRIBOS BITREN, en sus dos renglones: F/C y F/S
   van combinadas de a dos, con el valor arriba; BITREN, TRA, CHOFER, CLIENTE
   y LUG / DIA llevan un valor en cada renglón (el de cada parte). */
const DE_DOS = ["fc", "fs"];
const EN_LOS_DOS = ["bitren", "tra", "chofer", "cliente", "lug"];

/* Suma a la hoja de arribos los bitrenes que no tiene. Devuelve
   `{hoja, agregados, yaEstaban, salteadas, nuevas}`; la hoja que entra no se
   toca. `nuevas` son los renglones que se escribieron (índices desde 0, los
   dos de cada bitren): ahí después va la UBICACIÓN (`shared/ubicacionAlAgregar`). Un
   bitren ya está si la hoja tiene ese semi con el mismo F/C (el día de
   carga); la 2da fila de cada bitren no repite el F/C (está combinado), así
   que se arrastra el de arriba. El F/S es el día siguiente al F/C y va como
   el F/C: sólo el día y sólo en la 1ra fila. Lo que se carga hoy en Río
   Grande sale mañana (Lautaro, 19/10). Se escribe sólo en renglones que van
   después del último con algo, que están vacíos: lo que él ya escribió no se
   toca.

   SUS COMBINADAS: él combina celdas a mano («Combinar y centrar», 19/10).
   Escribir debajo de una combinada suya deja el valor donde no se ve, y
   ponerle otra encima la pisa. Así que cada bitren va en los primeros dos
   renglones vacíos donde ninguna combinada suya toca sus celdas (F/C, F/S,
   BITREN, TRA, CHOFER, CLIENTE y LUG / DIA, en esos dos renglones), salvo
   las de F/C y F/S justo de esos dos renglones: ésas son las que se iban a
   poner, así que se usan las suyas y no se repiten. No como en SALIDAS BITREN, donde casi todo va
   sólo arriba: acá el tractor, el chofer y el cliente van en los dos
   renglones, y una combinada suya de dos renglones en esas columnas taparía
   los de la 2da parte. Si el lugar no sirve, el bitren baja de a un renglón:
   más abajo siempre hay lugar (la hoja crece), así que se agrega igual. Los
   renglones que se saltean quedan como estaban y se devuelven en
   `salteadas` (números de fila, como se ven) para decirlo en la pantalla.
   Las combinadas de él en las columnas que el bitren no escribe (UBICACIÓN,
   los pernoctes, la tarjeta) no cambian nada. */
export function agregarAArribos(hoja, bitrenes, fecha) {
  const enc = encabezadoArribos(hoja);
  if (!enc) return { hoja, agregados: 0, yaEstaban: 0, salteadas: [], nuevas: [] };
  const { fila, cols } = enc;
  const fc = String(Number(String(fecha).split("-")[2] || ""));
  const sale = diaSiguiente(fecha);
  const fs = sale ? String(Number(sale.slice(8))) : "";
  const celdas = (hoja.celdas || []).map((r) => [...(r || [])]);
  const ancho = Math.max(hoja.cols || 0, ...celdas.map((r) => r.length));
  const hay = new Set();
  let fcArriba = "";
  let ultima = fila;
  celdas.forEach((r, i) => {
    if (i <= fila) return;
    if (r.some((v) => txt(v))) ultima = i;
    const f = cols.fc === undefined ? "" : txt(r[cols.fc]);
    if (f) fcArriba = f;
    const bit = txt(r[cols.bitren]);
    if (bit) hay.add(`${f || fcArriba}|${bit}`);
  });
  const lista = Array.isArray(hoja.combinadas) ? hoja.combinadas : [];
  const suyas = lista.map(rangoCombinada).filter((m) => m && (m.r0 !== m.r1 || m.c0 !== m.c1));
  const deDos = DE_DOS.map((k) => cols[k]).filter((c) => c !== undefined);
  const huella = [...deDos, ...EN_LOS_DOS.map((k) => cols[k]).filter((c) => c !== undefined)];
  const esLaDeDos = (m, r) => m.r0 === r && m.r1 === r + 1 && m.c0 === m.c1 && deDos.includes(m.c0);
  const tocaLaHuella = (m, r) => m.r0 <= r + 1 && m.r1 >= r && huella.some((c) => m.c0 <= c && c <= m.c1);
  const sirve = (r) => suyas.every((m) => esLaDeDos(m, r) || !tocaLaHuella(m, r));
  const combinadas = [...lista];
  const salteadas = [];
  const nuevas = [];
  let agregados = 0;
  let yaEstaban = 0;
  let en = ultima + 1;
  const vacia = () => Array.from({ length: ancho }, () => "");
  for (const { primera, segunda } of bitrenes) {
    if (hay.has(`${fc}|${primera.semi}`) || hay.has(`${fc}|${segunda.semi}`)) {
      yaEstaban += 1;
      continue;
    }
    while (!sirve(en)) {
      salteadas.push(en + 1);
      en += 1;
    }
    const desde = en;
    [primera, segunda].forEach((p, k) => {
      const r = celdas[desde + k] ? [...celdas[desde + k]] : vacia();
      while (r.length < ancho) r.push("");
      const poner = (c, v) => {
        if (c !== undefined) r[c] = v;
      };
      poner(cols.fc, k === 0 ? fc : "");
      if (k === 0) poner(cols.fs, fs);
      poner(cols.bitren, p.semi);
      poner(cols.tra, p.tractor);
      poner(cols.chofer, p.chofer);
      poner(cols.cliente, p.lugar);
      poner(cols.lug, p.caract);
      celdas[desde + k] = r;
    });
    for (const c of [cols.fc, cols.fs]) {
      if (c === undefined || suyas.some((m) => esLaDeDos(m, desde) && m.c0 === c)) continue;
      combinadas.push(`${colALetra(c)}${desde + 1}:${colALetra(c)}${desde + 2}`);
    }
    hay.add(`${fc}|${primera.semi}`);
    nuevas.push(desde, desde + 1);
    en += 2;
    agregados += 1;
  }
  for (let i = 0; i < celdas.length; i++) if (!celdas[i]) celdas[i] = vacia();
  return {
    hoja: { ...hoja, celdas, combinadas, filas: Math.max(hoja.filas || 0, celdas.length), cols: ancho },
    agregados,
    yaEstaban,
    salteadas,
    nuevas,
  };
}

/* Lo que dice la pantalla de los renglones que se saltearon: «Las filas 7 a 9
   y 12 quedaron como estaban: …», o "" si no se salteó ninguno. `que` es lo
   que se estaba agregando: un bitren, o un furgón en la SALIDAS de furgones
   (`salidasFurgones`). */
export function textoSalteadas(filas, que = "bitren") {
  const n = [...new Set(filas || [])].sort((a, b) => a - b);
  if (!n.length) return "";
  const tramos = [];
  for (const f of n) {
    const t = tramos[tramos.length - 1];
    if (t && f === t[1] + 1) t[1] = f;
    else tramos.push([f, f]);
  }
  const partes = tramos.flatMap(([a, b]) => {
    if (b - a >= 2) return [`${a} a ${b}`];
    return a === b ? [String(a)] : [String(a), String(b)];
  });
  const juntas = partes.length === 1 ? partes[0] : `${partes.slice(0, -1).join(", ")} y ${partes[partes.length - 1]}`;
  const porque = `tus celdas combinadas ahí taparían parte del ${que}.`;
  return n.length === 1
    ? `La fila ${juntas} quedó como estaba: ${porque}`
    : `Las filas ${juntas} quedaron como estaban: ${porque}`;
}

/* El TRACTOR que va a Enganches. El interno; y si es un fletero (FLT: en la
   Torrecillas dice PP) y la fila trae la patente de su camión, la patente.
   Es la regla de esa pantalla (Lautaro, 15/10: un fletero va con la patente
   de su camión, no con FLT): el correo lleva esa patente, y la salvedad y el
   lastre la muestran con FLT adelante («FLT - KOM 245»). Si la patente es la
   de un tractor nuestro, FlotaBot pone el interno, como lo deja él a mano.
   Sin patente (o con algo que no es una: «-», «S/D»), FLT. La patente, vieja
   o Mercosur, como la reconoce FlotaBot. */
const PATENTE = /^(?:[A-Z]{3}\d{3}|[A-Z]{2}\d{3}[A-Z]{2})$/;

export const tractorParaEnganche = (p) =>
  p.tractor === FLT && PATENTE.test(pelado(p.patTractor)) ? txt(p.patTractor) : p.tractor;

/* Lo que va a Enganches (FlotaBot): cada bitren en dos filas, la 1ra del
   titular y la 2da del que la cruza hasta Gallegos. La fecha que va es la de
   salida, el día siguiente al de carga (Lautaro, 19/10: «LO QUE CARGA HOY EN
   RGD NO SALE HOY SALE EL OTRO DIA»). */
export function filasDeEnganche(bitrenes, fechaCarga) {
  const fecha = diaSiguiente(fechaCarga);
  return bitrenes.flatMap(({ primera, segunda }) =>
    [primera, segunda].map((p) => ({
      fecha,
      bitren: p.semi,
      tractor: tractorParaEnganche(p),
      chofer: p.chofer,
      cliente: primera.lugar,
    })),
  );
}

/* La línea de la pantalla después de mandar los bitrenes a Enganches (los
   de Río Gallegos) al agregarlos a la planilla (ticket 562). `r` es lo que
   contesta FlotaBot (`nuevas`, `ya_estaban`, `fallaron`), o `{ok: false,
   mensaje}`, o null si ni contestó. La planilla ya quedó escrita: si falla,
   se dice que ahí no pasó nada y que apretar de nuevo no repite. */
export function textoEnganchesGallegos(r) {
  const n = (x) => Number(x) || 0;
  if (!r?.ok) {
    const porque = txt(r?.mensaje || r?.error) || "no contestó";
    return `Enganches de Río Gallegos: no pude cargarlos (${porque}). En la planilla quedaron igual; `
      + "apretá «Agregar» de nuevo para cargarlos: lo que ya está no se repite.";
  }
  const partes = [];
  if (n(r.nuevas)) partes.push(`${n(r.nuevas)} ${n(r.nuevas) === 1 ? "enganche cargado" : "enganches cargados"}`);
  if (n(r.ya_estaban)) partes.push(`${n(r.ya_estaban)} ya ${n(r.ya_estaban) === 1 ? "estaba" : "estaban"}`);
  if (n(r.fallaron)) partes.push(`${n(r.fallaron)} ${n(r.fallaron) === 1 ? "no se pudo cargar" : "no se pudieron cargar"}`);
  return `Enganches de Río Gallegos: ${partes.length ? partes.join(", ") : "nada para cargar"}.`;
}
